import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBookOpen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	"data-icon": "book-open",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 6C13.6357 6 15.088 6.78547 16.0002 7.99981C16.8708 6.83978 18.2359 6.07065 19.7831 6.00462L20 6H28C29.0544 6 29.9182 6.81588 29.9945 7.85074L30 8V24C30 25.0544 29.1841 25.9182 28.1493 25.9945L28 26H20C18.4023 26 17.0963 27.2489 17.0051 28.8237L17 29C17 29.5641 16.642 29.8895 16.229 29.9763L16.0627 29.9982L15.9378 29.9983L15.8753 29.9923C15.4551 29.946 15.0648 29.6604 15.0073 29.136L14.9949 28.8237C14.907 27.3072 13.6928 26.093 12.1763 26.0051L12 26H4C2.94564 26 2.08183 25.1841 2.00549 24.1493L2 24V8C2 6.94564 2.81588 6.08183 3.85074 6.00549L4 6H12ZM12 8H4V24H12C12.9992 24 13.9299 24.2931 14.7109 24.798L14.9202 24.9409L15 25.001V11C15 9.46149 13.8419 8.19348 12.3499 8.02018L12.1763 8.00509L12 8ZM20 8H28V24H20L19.7831 24.0046C18.7411 24.0491 17.7818 24.4125 17.0001 24.9996L17 11L17.0051 10.8237C17.0963 9.24892 18.4023 8 20 8Z"
	})
});
export default SvgBookOpen;
